import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { imageUrl } from '../lib/images'

export default function Youth() {
  return (
    <div>
      <PageHeader
        badge="Til dig som er ung"
        title="Børn og unge"
        subtitle="Hos Unges Fremtid ser vi dine ressourcer, dine drømme og dit potentiale – og vi er her for at støtte dig hele vejen."
        breadcrumb={[{ label: 'Børn og unge' }]}
      />

      {/* SEKTION 2: BØRN OG UNGE (Foto: COLOURBOX62002417) */}
      <section className="py-16 sm:py-24 bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Du rummer ressourcer og drømme
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight">
                Børn og unge
              </h2>
              <div className="space-y-4 text-neutral-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Børn og unge i dag rummer enorme ressourcer. De er nysgerrige, kreative, reflekterede og ofte langt mere åbne over for forskellighed end tidligere generationer. De engagerer sig i verden omkring dem, stiller spørgsmål og har både drømme og ambitioner for deres liv.
                </p>
                <p>
                  Men ikke alle får de samme muligheder for at føre drømmene ud i livet. Nogle børn og unge kæmper med ensomhed, mistrivsel, skolefravær, svære familieforhold, manglende tro på egne evner eller følelsen af ikke rigtigt at høre til. For nogle bliver vejen gennem skole og uddannelse og videre ind i voksenlivet derfor langt mere vanskelig end for andre.
                </p>
              </div>

              <div className="pt-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="tel:25778646"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-bold text-base px-6 py-3.5 rounded-full transition-colors shadow-xs"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true" />
                  <span className="whitespace-nowrap">Ring eller skriv: 25 77 86 46</span>
                </a>
                <Link
                  to="/kontakt"
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-neutral-100 hover:bg-neutral-200 text-[#0c304d] font-semibold text-base px-6 py-3.5 rounded-full transition-colors"
                >
                  <span>Skriv en besked</span>
                  <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>

            {/* Billede: COLOURBOX62002417 */}
            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-neutral-100">
                <img
                  src={imageUrl('/_assets/colourbox62002417.jpg', 'width=800,quality=85,format=auto')}
                  alt="Portræt af ung mand med blå øjne og blond hår"
                  className="w-full h-[460px] object-cover"
                  width={500}
                  height={460}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEKTION 3: HVORDAN GØR VI EN FORSKEL? (Foto: Foto7) */}
      <section className="py-16 sm:py-24 bg-[#faf9f6] border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Billede: Foto7 */}
            <div className="lg:col-span-5 order-2 lg:order-1">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-neutral-100">
                <img
                  src={imageUrl('/_assets/foto7.jpg', 'width=800,quality=85,format=auto')}
                  alt="Kvinder i caféarbejde og godt samarbejde"
                  className="w-full h-[460px] object-cover"
                  width={500}
                  height={460}
                />
              </div>
            </div>

            {/* Tekst */}
            <div className="lg:col-span-7 order-1 lg:order-2 space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Tryghed og relationer
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight">
                Hvordan gør vi en forskel?
              </h2>
              <div className="space-y-4 text-neutral-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Det positive er, at der ofte skal overraskende lidt til for at gøre en stor forskel. Et menneske, der ser dem. En voksen, der lytter. En mentor, der bliver ved med at tro på dem, også når de selv har mistet troen. En invitation ind i et fællesskab, en hjælpende hånd til den første praktikplads eller bare én, der spørger: Hvordan går det egentlig?
                </p>
                <p>
                  For et udsat barn eller en ung kan én stabil og positiv relation blive begyndelsen på noget helt nyt. Den kan skabe håb, styrke selvværdet og åbne døren til fællesskab, uddannelse og arbejde.
                </p>
                <p className="font-bold text-[#0c304d]">
                  Nogle gange skal der ikke mere til end ét menneske, der vælger at gøre en forskel.
                </p>
                <p className="text-[#f39223] font-extrabold text-xl sm:text-2xl">
                  Og den forskel kan vare resten af livet.
                </p>
              </div>

              <div className="p-5 rounded-2xl bg-white border border-neutral-200/90 shadow-2xs space-y-2">
                <p className="font-bold text-[#0c304d] flex items-center gap-2">
                  <i className="fa-solid fa-lock text-[#f39223]" aria-hidden="true" />
                  <span>Fortroligt, trygt og gratis</span>
                </p>
                <p className="text-sm text-neutral-600 leading-relaxed">
                  Det koster aldrig noget at få hjælp eller deltage i vores forløb. Vi har tavshedspligt, dømmer aldrig, og vi tager tingene i dit helt eget tempo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SÅDAN KOMMER DU I GANG */}
      <section id="forloeb" className="py-16 sm:py-24 bg-white scroll-mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-4 mb-16">
            <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
              Det første skridt
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0c304d] tracking-tight">
              Hvordan kommer du i kontakt med os?
            </h2>
            <p className="text-neutral-600 text-base sm:text-lg">
              Det er nemt, uforpligtende og uden krav om henvisning.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-[#faf9f6] rounded-3xl p-8 border border-neutral-200/90 relative">
              <span className="w-10 h-10 rounded-full bg-[#f39223] text-white flex items-center justify-center font-bold text-lg mb-6">
                1
              </span>
              <h3 className="text-xl font-bold text-[#0c304d] mb-3">
                Tag kontakt
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed mb-4">
                Ring eller send en sms til 25 77 86 46, skriv en mail til ungesfremtid@outlook.dk, eller udfyld kontaktformularen.
              </p>
            </div>

            <div className="bg-[#faf9f6] rounded-3xl p-8 border border-neutral-200/90 relative">
              <span className="w-10 h-10 rounded-full bg-[#0c304d] text-white flex items-center justify-center font-bold text-lg mb-6">
                2
              </span>
              <h3 className="text-xl font-bold text-[#0c304d] mb-3">
                Uforpligtende snak
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed mb-4">
                Vi tager en rolig, uforpligtende snak over en sodavand eller kop kaffe. Du bestemmer, hvad vi skal tale om.
              </p>
            </div>

            <div className="bg-[#faf9f6] rounded-3xl p-8 border border-neutral-200/90 relative">
              <span className="w-10 h-10 rounded-full bg-emerald-600 text-white flex items-center justify-center font-bold text-lg mb-6">
                3
              </span>
              <h3 className="text-xl font-bold text-[#0c304d] mb-3">
                Vi finder vejen sammen
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed mb-4">
                Har du en ide til et projekt, vi sammen kan lave for at hjælpe børn og unge, så tag kontakt.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-bold text-base px-8 py-3.5 rounded-full transition-colors cursor-pointer shadow-md"
            >
              <span>Kontakt os i dag</span>
              <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}
